<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "phone" });
export let css = "";
export let isScaling = true;
</script>

<svg xmlns = 'http://www.w3.org/2000/svg'
    fill = 'none'
    viewBox = '0 0 18 18'
    on:mouseenter
    on:mouseleave
    on:keypress
    on:click
    class = { `s8-icon ${ css }` }
    stroke = '#272711'
>
    <g clip-path = 'url(#clip0_1791_29695)'>
        <!-- eslint-disable max-len -->
            <path
                d = 'M10.5372 4.5C11.2698 4.64292 11.943 5.00119 12.4708 5.52895C12.9986 6.05671 13.3568 6.72995 13.4997 7.4625M10.5372 1.5C12.0592 1.66908 13.4784 2.35063 14.5619 3.43276C15.6454 4.51488 16.3288 5.93326 16.4997 7.455M7.66998 10.3973C6.7688 9.49612 6.05721 8.47714 5.53521 7.38992C5.49031 7.29641 5.46786 7.24965 5.45061 7.19048C5.38932 6.98021 5.43334 6.72202 5.56085 6.54395C5.59673 6.49384 5.6396 6.45097 5.72533 6.36524C5.98754 6.10303 6.11864 5.97193 6.20435 5.8401C6.5276 5.34293 6.5276 4.70199 6.20435 4.20482C6.11864 4.07299 5.98754 3.94189 5.72533 3.67968L5.57918 3.53353C5.1806 3.13495 4.98131 2.93566 4.76727 2.8274C4.3416 2.6121 3.8389 2.6121 3.41323 2.8274C3.1992 2.93566 2.99991 3.13495 2.60132 3.53353L2.4831 3.65176C2.08588 4.04897 1.88727 4.24758 1.73559 4.51761C1.56727 4.81724 1.44625 5.28261 1.44727 5.62627C1.44819 5.93598 1.50827 6.14765 1.62843 6.57098C2.27415 8.84603 3.49251 10.9928 5.28349 12.7838C7.07448 14.5748 9.22125 15.7931 11.4963 16.4389C11.9196 16.559 12.1313 16.6191 12.441 16.62C12.7847 16.621 13.25 16.5 13.5497 16.3317C13.8197 16.18 14.0183 15.9814 14.4155 15.5842L14.5337 15.466C14.9323 15.0674 15.1316 14.8681 15.2399 14.6541C15.4552 14.2284 15.4552 13.7257 15.2399 13.3C15.1316 13.086 14.9323 12.8867 14.5337 12.4881L14.3876 12.3419C14.1254 12.0797 13.9943 11.9486 13.8625 11.8629C13.3653 11.5397 12.7244 11.5397 12.2272 11.8629C12.0954 11.9486 11.9643 12.0797 11.702 12.3419C11.6163 12.4277 11.5734 12.4706 11.5233 12.5064C11.3453 12.6339 11.0871 12.678 10.8768 12.6167C10.8176 12.5994 10.7709 12.577 10.6774 12.5321C9.59014 12.0101 8.57116 11.2985 7.66998 10.3973Z'
                stroke-width = '1.3'
                stroke-linecap = 'round'
                stroke-linejoin = 'round'
                vector-effect = { isScaling ? 'none' : 'non-scaling-stroke' }>
            </path>
        <!-- eslint-enable -->
    </g>
    <defs>
        <clipPath id = 'clip0_1791_29695'>
            <rect width = '18' height = '18' fill = 'white'/>
        </clipPath>
    </defs>
</svg>